"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var model_1 = require("../../diagram/model");
var async_1 = require("../../viewUtils/async");
var events_1 = require("../../viewUtils/events");
var treeModel_1 = require("./treeModel");
var leaf_1 = require("./leaf");
var CLASS_NAME = 'ontodia-class-tree';
var MIN_TERM_LENGTH = 3;
var ClassTree = /** @class */ (function (_super) {
    tslib_1.__extends(ClassTree, _super);
    function ClassTree(props) {
        var _this = _super.call(this, props) || this;
        _this.listener = new events_1.EventObserver();
        _this.delayedClassUpdate = new async_1.Debouncer();
        _this.delayedSearch = new async_1.Debouncer(200 /* ms */);
        _this.onSearchTextChange = function (e) {
            var requestedSearchText = e.currentTarget.value;
            _this.setState({ requestedSearchText: requestedSearchText });
            _this.delayedSearch.call(_this.performSearch);
        };
        _this.performSearch = function () {
            var _a = _this.state, requestedSearchText = _a.requestedSearchText, appliedSearchText = _a.appliedSearchText;
            var requested = normalizeSearchText(requestedSearchText);
            if (requested === appliedSearchText) {
                return;
            }
            if (requested.length < MIN_TERM_LENGTH) {
                _this.setState(function (state) { return ({
                    appliedSearchText: undefined,
                    filteredRoots: state.roots,
                }); });
            }
            else {
                var view_1 = _this.props.view;
                _this.setState(function (state) { return ({
                    appliedSearchText: requested,
                    filteredRoots: filterTree(state.roots, requested, view_1.getLanguage()),
                }); });
            }
        };
        _this.onSelectNode = function (node) {
            var onClassSelected = _this.props.onClassSelected;
            _this.setState({ selectedNode: node });
            onClassSelected(node.model.id);
        };
        _this.refreshClassTree = function () {
            var _a = _this.props, editor = _a.editor, view = _a.view;
            var lang = view.getLanguage();
            var mapClass = function (model) {
                var richClass = view.model.createClass(model.id);
                return {
                    model: richClass,
                    label: model_1.formatLocalizedLabel(richClass.id, richClass.label, lang),
                    derived: model.children.map(mapClass),
                };
            };
            var roots = editor.model.getClasses().map(mapClass);
            _this.setState(function (state) {
                var sortedRoots = sortTree(roots, lang);
                var filteredRoots = state.appliedSearchText
                    ? filterTree(sortedRoots, state.appliedSearchText, lang)
                    : sortedRoots;
                return { roots: sortedRoots, filteredRoots: filteredRoots };
            });
        };
        _this.state = {
            roots: [],
            filteredRoots: [],
            requestedSearchText: '',
            appliedSearchText: '',
        };
        return _this;
    }
    ClassTree.prototype.render = function () {
        var view = this.props.view;
        var _a = this.state, requestedSearchText = _a.requestedSearchText, appliedSearchText = _a.appliedSearchText, filteredRoots = _a.filteredRoots, selectedNode = _a.selectedNode;
        var normalizedSearchText = normalizeSearchText(requestedSearchText);
        // highlight search term only if actual tree is already filtered by current or previous term:
        //  - this immediately highlights typed characters thus making it look more responsive,
        //  - prevents expanding non-filtered tree (which can be too large) just to highlight the term
        var searchText = appliedSearchText ? normalizedSearchText : undefined;
        return (React.createElement("div", { className: CLASS_NAME },
            React.createElement("div", { className: CLASS_NAME + "__filter" },
                React.createElement("div", { className: CLASS_NAME + "__filter-group" },
                    React.createElement("input", { type: 'text', className: 'search-input ontodia-form-control', placeholder: 'Search for...', value: this.state.requestedSearchText, onChange: this.onSearchTextChange }))),
            React.createElement(leaf_1.Forest, { className: CLASS_NAME + "__tree", view: view, nodes: filteredRoots, searchText: searchText, selectedNode: selectedNode, onSelect: this.onSelectNode })));
    };
    ClassTree.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, view = _a.view, editor = _a.editor;
        this.listener.listen(view.events, 'changeLanguage', function () { return _this.refreshClassTree(); });
        this.listener.listen(editor.model.events, 'changeClassTree', function () {
            _this.refreshClassTree();
        });
        this.listener.listen(editor.model.events, 'classEvent', function (_a) {
            var data = _a.data;
            if (data.changeLabel || data.changeCount) {
                _this.delayedClassUpdate.call(_this.refreshClassTree);
            }
        });
        this.refreshClassTree();
    };
    ClassTree.prototype.componentWillUnmount = function () {
        this.listener.stopListening();
        this.delayedClassUpdate.dispose();
        this.delayedSearch.dispose();
    };
    return ClassTree;
}(React.Component));
exports.ClassTree = ClassTree;
function normalizeSearchText(text) {
    return text.trim().toLowerCase();
}
function sortTree(roots, lang) {
    if (roots.length === 0) {
        return roots;
    }
    var compareByLabel = function (left, right) {
        var leftLabel = model_1.formatLocalizedLabel(left.model.id, left.model.label, lang);
        var rightLabel = model_1.formatLocalizedLabel(right.model.id, right.model.label, lang);
        return leftLabel.localeCompare(rightLabel);
    };
    var mapped = roots.map(function (root) { return treeModel_1.TreeNode.setDerived(root, sortTree(root.derived, lang)); });
    mapped.sort(compareByLabel);
    return mapped;
}
function filterTree(roots, searchText, lang) {
    if (roots.length === 0) {
        return roots;
    }
    return roots
        .map(function (root) { return treeModel_1.TreeNode.setDerived(root, filterTree(root.derived, searchText, lang)); })
        .filter(function (root) {
        if (root.derived.length > 0) {
            // keep parent if children is included
            return true;
        }
        return root.label.toLowerCase().indexOf(searchText) >= 0;
    });
}
